module.exports = __webpack_public_path__ + "static/img/star_person_team.099d5565.png";